import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import translate from '@i18n'
import IconButton from '@components/Buttons/IconButton'

export type FollowMyTeamDrawerHeaderProps = {
  title: string
  onClose: () => void
} & (
  | {
      showBackButton?: false
      onBack?: () => void
    }
  | {
      showBackButton: true
      onBack: () => void
    }
)

const Header = styled.div`
  ${({
    theme: {
      colors: { strokeDefaultDisabled },
    },
  }) => css`
    height: 48px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid ${strokeDefaultDisabled};
    margin: 0 5px;
  `}
`

const Title = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          small: { bundledCSS: headingSmallCSS },
        },
      },
    },
  }) => css`
    ${headingSmallCSS}
  `}
`

const BackIconButton = styled(IconButton)`
  position: absolute;
  left: 16px;
`

const CloseIconButton = styled(IconButton)`
  position: absolute;
  right: 16px;
`

const FollowMyTeamDrawerHeader: FunctionComponent<
  FollowMyTeamDrawerHeaderProps
> = ({ title, showBackButton, onBack, onClose }) => {
  const theme = useTheme()

  return (
    <Header>
      {showBackButton && onBack && (
        <BackIconButton
          ariaLabel={translate('back')}
          buttonSize={48}
          onClick={onBack}
          iconName="chevron-left"
          iconSize={24}
          iconColor={theme.colors.iconDefault}
        />
      )}
      <Title>{title}</Title>
      <CloseIconButton
        ariaLabel={translate('close')}
        buttonSize={48}
        onClick={onClose}
        iconName="xmark-large"
        iconSize={24}
        iconColor={theme.colors.iconDefault}
      />
    </Header>
  )
}

export default FollowMyTeamDrawerHeader
